import TabSwitcher, { TabCodes } from 'domain/TabSwitcher';
import { Config, PrivilegeChecker } from 'omni-common-ui';
import Privileges from 'domain/Privileges';
import { routes as coreAndCatchUp } from './CoreAndCatchUp';
import { routes as spinListView } from './SpinListView';
import {
  coreCatchUpWritingAssignment,
  spinWritingAssignment,
} from './StudentWritingAssignment';
import WritingAssignment from './component';
import { accessors } from 'data/WritingAssignment';

export const writingAssignmentRootPath = 'writing-assignment';

export const LESSON_CATEGORY = {
  CORE_CATCH_UP: 'coreCatchUp',
  SPIN: 'spin',
};

export const TABS = {
  [LESSON_CATEGORY.CORE_CATCH_UP]: 'core-catch',
  [LESSON_CATEGORY.SPIN]: 'spin',
};

export const isSpinWritingAssignmentEnabled = () => Config.get('enableSpinWritingAssignment');

export const isTabActive = (props, lessonCategory) => {
  const { location: { pathname }, params: { lessonSeq, activityId } } = props;
  const currentLessonCategory = accessors.getLessonCategory({ lessonSeq, activityId });
  return pathname.includes(TABS[lessonCategory]) || lessonCategory === currentLessonCategory;
};

export default ({ getState }) => ({
  path: writingAssignmentRootPath,
  component: WritingAssignment,
  breadcrumbLabels: (props) => {
    const { params: { groupId }, buildRoute } = props;
    return {
      label: 'writing assignment',
      href: buildRoute(`/group/${groupId}/writing-assignment`),
    };
  },
  canAccess: ({ params }) =>
    PrivilegeChecker.hasPrivilege(getState(), Privileges.AssignHomework.View) &&
      TabSwitcher.isTabEnabled(getState(), params.groupId, TabCodes.WritingAssignment),
  secondLevelTabs: (props) => {
    if (! isSpinWritingAssignmentEnabled()) {
      return [];
    }
    const { location: { pathname }, buildRoute, push, params } = props;
    if (! pathname.includes(writingAssignmentRootPath)) return [];
    return [
      {
        text: 'Core & Catch-up',
        onClick: () =>
            push(buildRoute(`/group/:groupId/${writingAssignmentRootPath}/${TABS[LESSON_CATEGORY.CORE_CATCH_UP]}`, params)),
        isActive: isTabActive(props, LESSON_CATEGORY.CORE_CATCH_UP),
      },
      {
        text: 'Spin',
        onClick: () => push(buildRoute(`/group/:groupId/${writingAssignmentRootPath}/${TABS[LESSON_CATEGORY.SPIN]}`, params)),
        isActive: isTabActive(props, LESSON_CATEGORY.SPIN),
      },
    ];
  },
  tab: {
    label: 'Writing Assignment',
    order: 9,
    isVisible: (params) =>
      PrivilegeChecker.hasPrivilege(getState(), Privileges.AssignHomework.View) &&
        TabSwitcher.isTabEnabled(getState(), params.groupId, TabCodes.WritingAssignment),
  },
  childRoutes: [
    coreAndCatchUp,
    isSpinWritingAssignmentEnabled() && spinListView,
    coreCatchUpWritingAssignment,
    spinWritingAssignment,
  ],
});



// WEBPACK FOOTER //
// ./containers/Group/WritingAssignment/routes.js